/**
 * Capture opaque leo_artwork handoff on storefront pages.
 * Product-scoped when on a PDP; otherwise pending until a product is chosen.
 * Strips leo_artwork from the visible URL after capture.
 */
(function () {
  var PREFIX = 'leo_artwork_handoff:'
  var PENDING = 'leo_artwork_pending'
  var LEGACY = 'leo_artwork_handoff'
  var QUERY = 'leo_artwork'

  function productHandleFromPath() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/i)
    if (!match) return null
    try {
      return decodeURIComponent(match[1]).toLowerCase()
    } catch {
      return String(match[1]).toLowerCase()
    }
  }

  try {
    // Drop legacy global key (cross-product leak).
    sessionStorage.removeItem(LEGACY)

    var url = new URL(window.location.href)
    var token = url.searchParams.get(QUERY)
    if (!token) return

    var handle = productHandleFromPath()
    if (handle) {
      sessionStorage.setItem(PREFIX + handle, token)
      sessionStorage.removeItem(PENDING)
    } else {
      sessionStorage.setItem(PENDING, token)
    }

    url.searchParams.delete(QUERY)
    var next = url.pathname + (url.search ? url.search : '') + url.hash
    window.history.replaceState({}, '', next)
  } catch {
    // ignore
  }
})()
